module.exports = __webpack_public_path__ + "img/id.d76140ae.png";